module.exports = __webpack_public_path__ + "img/Fukka-FukaSeat_BlitishGreen.9fdf2ed3.png";